import { ComponentsPlatformService } from '@wix/editor-platform-manifest-services';
import { CompRef } from '@wix/document-services-types';
import {
  hasAnyMeaningfulValue,
  isAllowedStylePresent,
} from '../common/actionValidators/actionVisibilityRules';
import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import { getAllowedPropertiesForAction } from '../constants';
import { CSS_PROPERTIES, DATA } from '@wix/component-protocol/schema';
import { hasDataType } from '../../../utils/helpers';
import { Meaningfulness } from '../common/meaningfulnessPredicates';

import { EditorPointer } from '@wix/editor-document-logic-api';

/**
 * Stroke action validator
 *
 * Rules:
 * - Show if element has stroke or strokeWidth in manifest
 *
 * @param componentsAPI - Components platform service
 * @param editorPointers - Selected editor pointers
 * @returns true if stroke action should be shown
 */
export const createStrokeValidator = () => {
  return (
    componentsAPI: ComponentsPlatformService,
    editorPointers: EditorPointer<CompRef>[],
  ): boolean => {
    const hasVectorArtData = hasDataType(
      componentsAPI.components.getData(editorPointers),
      DATA.DATA_TYPE.vectorArt,
    );

    if (!hasVectorArtData) {
      return false;
    }

    const rootContexts = editorPointers.map((editorPointer) =>
      componentsAPI.buildManifestAPI({ editorPointers: [editorPointer] }),
    );

    const strokeProperties = new Set(
      getAllowedPropertiesForAction(StylesDerivedNativeActions.strokeStyles),
    );

    const strokeWidthProperties = new Set([
      CSS_PROPERTIES.CSS_PROPERTY_TYPE.strokeWidth,
    ]);

    for (const rootContext of rootContexts) {
      if (
        isAllowedStylePresent(rootContext, strokeProperties) ||
        hasAnyMeaningfulValue(
          rootContext,
          strokeWidthProperties,
          Meaningfulness.meaningCheck(StylesDerivedNativeActions.strokeStyles),
        )
      ) {
        return true;
      }
    }

    return false;
  };
};
